import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LangContext";

export default function NotFound() {
  const navigate = useNavigate();
  const { lang } = useLang();

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div style={{ textAlign: "center", maxWidth: 400 }}>
        <h1 style={{ fontSize: 72, fontWeight: 700, color: "#1d4ed8", margin: "0 0 8px", fontFamily: "Georgia, serif" }}>404</h1>
        <h2 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 12px", fontFamily: "sans-serif" }}>Pagina nu există</h2>
        <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 24px", fontFamily: "sans-serif" }}>
          Pagina pe care o cauți nu a fost găsită sau a fost mutată.
        </p>
        <button onClick={() => navigate("/dashboard")}
          style={{ padding: "10px 24px", background: "#1d4ed8", color: "#fff", border: "none", borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: "pointer", fontFamily: "sans-serif" }}>
          {lang.common.back} Dashboard
        </button>
      </div>
    </div>
  );
}